
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { OpportunityFormValues } from "./schema";
import { useOpportunityForm } from "./useOpportunityForm";
import { useFetchOpportunities } from "./useFetchOpportunities";
import { useOpportunityActions } from "./useOpportunityActions";

export { opportunitySchema, type OpportunityFormValues } from "./schema";
export { useFetchOpportunities } from "./useFetchOpportunities";

export const useOpportunities = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { user } = useAuth();
  
  const { opportunities, loading, opportunityTypes, refreshOpportunities } = useFetchOpportunities({
    selectedType,
    searchQuery
  });

  const { handleDelete: deleteOpportunity } = useOpportunityActions();

  const handleFormSuccess = () => {
    setIsDialogOpen(false);
    refreshOpportunities();
  };
  
  const { form, handleSubmit } = useOpportunityForm(user, handleFormSuccess);

  // Wrapper for delete functionality that updates the local state
  const handleDelete = async (id: string) => {
    if (!user) {
      return;
    }
    
    const success = await deleteOpportunity(id, user.id);
    if (success) {
      refreshOpportunities();
    }
  };

  return {
    opportunities,
    loading,
    searchQuery,
    setSearchQuery,
    selectedType,
    setSelectedType,
    isDialogOpen,
    setIsDialogOpen,
    opportunityTypes,
    form,
    handleSubmit,
    handleDelete,
    user
  };
};
